"use client";

import React from "react";
import { useCountdown } from "@/lib/utilHooks";
import { bebas } from "@/helpers/bebas";

export default function EventCountdown({
  dateTimeString,
}: {
  dateTimeString: string;
}) {
  const { days, hours, minutes, seconds } = useCountdown(dateTimeString);

  const day = dateTimeString.split("-")[2].split("T")[0];
  const month = dateTimeString.split("-")[1];
  const year = dateTimeString.split("-")[0];
  const hour = dateTimeString.split("T")[1].split(":")[0];

  return (
    <>
      <p className="endDate mb-[.5rem]">{`${day}.${month}.${year} ${hour} UHR`}</p>
      <div className="countdownParent w-full flex justify-center gap-[.5rem] mb-[1rem]">
        <div
          className={`${bebas.className} countdownText w-full text-[4.5rem] lg:text-[6.5rem] leading-[.9em] relative after:content-["TAGE"] after:absolute after:font-normal after:text-[1.6rem] lg:after:text-[2rem] after:leading-[2rem] after:font-sans after:left-1/2 after:-translate-x-1/2 after:top-[100%]`}
        >
          {days}
        </div>
        <div
          className={`${bebas.className} countdownText countdownColon text-[4.5rem] lg:text-[6.5rem] leading-[.9em]`}
        >
          :
        </div>
        <div
          className={`${bebas.className} countdownText w-full text-[4.5rem] lg:text-[6.5rem] leading-[.9em] relative after:content-["STUNDEN"] after:absolute after:font-normal after:text-[1.6rem] lg:after:text-[2rem] after:leading-[2rem] after:font-sans after:left-1/2 after:-translate-x-1/2 after:top-[100%]`}
        >
          {hours}
        </div>
        <div
          className={`${bebas.className} countdownText countdownColon text-[4.5rem] lg:text-[6.5rem] leading-[.9em]`}
        >
          :
        </div>
        <div
          className={`${bebas.className} countdownText w-full text-[4.5rem] lg:text-[6.5rem] leading-[.9em] relative after:content-["MINUTEN"] after:absolute after:font-normal after:text-[1.6rem] lg:after:text-[2rem] after:leading-[2rem] after:font-sans after:left-1/2 after:-translate-x-1/2 after:top-[100%]`}
        >
          {minutes}
        </div>
        <div
          className={`${bebas.className} countdownText countdownColon text-[4.5rem] lg:text-[6.5rem] leading-[.9em]`}
        >
          :
        </div>
        <div
          className={`${bebas.className} countdownText w-full text-[4.5rem] lg:text-[6.5rem] leading-[.9em] relative after:content-["SEKUNDEN"] after:absolute after:font-normal after:text-[1.6rem] lg:after:text-[2rem] after:leading-[2rem] after:font-sans after:left-1/2 after:-translate-x-1/2 after:top-[100%]`}
        >
          {seconds}
        </div>
      </div>
    </>
  );
}
